<template>
    <div class="d-flex flex-column fill-height" id="p_branch_details">
        <v-row>
            <v-col cols="12" class="d-flex">
                <div ref="detailsContainer" style="width: 100%; display: flex; box-shadow: none">
                    <app-card :contentStyle="'padding: 8px; overflow: inherit;'" contentIsScrollable="false">
                        <template v-slot:title>
                            <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1"> {{ tb('Ficha de Cliente') }} </v-card-title>
                        </template>

                        <template v-slot:content>
                            <v-row class="d-flex flex-column px-2 mx-1 my-0 wrap-content">
                                <v-col cols="12" md="12" sm="12" class="d-flex justify-start px-0 pt-0">
                                    <v-tabs centered id="myprovet-tabs" v-model="selectedTabIndex" class="pt-1 ml-n1" style="border-radius: 8px" next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px" start show-arrows>
                                        <v-tabs-slider color="#154579"></v-tabs-slider>

                                        <v-tab class="myprovet-tab-item" v-for="item in tabItems" :key="item.tab">
                                            {{ tb(item.tab) }}
                                        </v-tab>
                                    </v-tabs>
                                </v-col>

                                <v-divider></v-divider>

                                <!-- Dados Fiscais -->
                                <div class="client-tab" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('Dados Fiscais')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col class="pr-0" style="max-width: fit-content">
                                            <div>
                                                <div class="title-text dark-blue-color" style="max-width: min-content; white-space: nowrap">{{ tb('Dados Fiscais') }}</div>
                                            </div>
                                        </v-col>
                                        <v-col class="pl-0">
                                            <div v-if="userStore.hasPermissionTo('Access branch details 360 button')">
                                                <v-btn text outlined class="myprovet-btn-cancel text-none px-8 mr-2" :href="link360" target="_blank"><img class="rotate-360-svg" src="/storage/assets/rotate-360.svg" />&nbsp;{{ $t('branchDetails.platform360') }}</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <div class="px-3" :style="`max-height: ${generalDataSize}px; overflow-y: auto;`">
                                        <v-row class="my-0">
                                            <v-col cols="6">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Nome')" :value="getBranchName"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Nome')" :value="getBranchName" v-model="editedGeneralData.name"></v-text-field>
                                            </v-col>

                                            <v-col cols="6">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Nº Contribuinte')" :value="getBranchNIF"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Nº Contribuinte')" v-model="editedGeneralData.taxpayer_number"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row class="my-0 wrap-contacts">
                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Nº Cliente')" :value="getBranchClientNumber"></v-text-field>
                                            </v-col>

                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Nº Filial')" :value="getBranchCompanyBranch"></v-text-field>
                                            </v-col>

                                            <v-col cols="3">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Telefone')" :value="getBranchTelephoneNumber"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Telefone')" v-model="editedGeneralData.telephone_number"></v-text-field>
                                            </v-col>

                                            <v-col cols="3">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Telemóvel')" :value="getBranchPhoneNumber"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Telemóvel')" v-model="editedGeneralData.phone_number"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row class="my-0 wrap-address">
                                            <v-col cols="6">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Morada Fiscal')" :value="getBranchAddress"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Morada Fiscal')" v-model="editedGeneralData.address"></v-text-field>
                                            </v-col>

                                            <v-col cols="6">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Email')" :value="getBranchEmail"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Email')" v-model="editedGeneralData.emails"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row class="my-0 wrap-locations">
                                            <v-col cols="6">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Código Postal')" :value="getPostalCode"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Código Postal')" v-model="editedGeneralData.postal_code"></v-text-field>
                                            </v-col>

                                            <v-col cols="6">
                                                <v-text-field v-if="!editingGeneralData" readonly :label="tb('Localidade')" :value="getLocation"></v-text-field>
                                                <v-text-field v-if="editingGeneralData" :label="tb('Localidade')" v-model="editedGeneralData.location"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row class="my-0">
                                            <v-col cols="12">
                                                <v-btn v-if="editingGeneralData" text class="myprovet-btn-ok px-8" @click="isConfirmChangesDialogOpen = true">{{ tb('Enviar Pedido') }}</v-btn>
                                                <v-btn v-if="editingGeneralData" text outlined class="myprovet-btn-cancel px-8 mr-2" @click="cancelGeneralDataChanges">{{ tb('Cancelar') }}</v-btn>

                                                <v-btn v-if="!editingGeneralData && userStore.hasPermissionTo('Request client details page changes')" text class="myprovet-btn-ok px-8" @click="startGeneralDataChanges">{{ tb('Alterar') }}</v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>

                                <!-- Dados Expedição -->
                                <div class="client-tab" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('Dados Expedição')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col cols="5">
                                            <div>
                                                <div class="title-text dark-blue-color">{{ tb('Dados Expedição') }}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="7" style="right: 0px">
                                            <div v-if="userStore.hasPermissionTo('Access branch details 360 button')">
                                                <v-btn text outlined class="myprovet-btn-cancel text-none px-8 mr-2" :href="link360" target="_blank"><img class="rotate-360-svg" src="/storage/assets/rotate-360.svg" />&nbsp;{{ $t('branchDetails.platform360') }}</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <div class="px-3">
                                        <v-data-table id="delivery_table"
                                            v-if="getBranchDeliveryAddresses"
                                            ref="datatableDetails"
                                            class="elevation-1 mt-2 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                            fixed-header
                                            multi-sort
                                            :headers="tHeaders(branch_addresses_headers)"
                                            :header-props="headerProps"
                                            :hide-default-headers="isMobile"
                                            :items="getBranchDeliveryAddresses"
                                            hide-default-footer
                                            disable-pagination
                                            :no-data-text="tb('Não existem moradas para mostrar.')"
                                            no-results-text="Não existem moradas para mostrar."
                                            :loading="isMobile?isLoading:false"
                                            :loading-text="$t('table.loading')"
                                        >
                                            <template #item.name="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.name }}
                                                </div>
                                            </template>

                                            <template #item.address="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.address }}
                                                </div>
                                            </template>

                                            <template #item.location="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.location }}
                                                </div>
                                            </template>

                                            <template #item.postal_code="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.postal_code }}
                                                </div>
                                            </template>

                                            <template #item.telephone_number="scope">
                                                {{ scope.item.telephone_number }}
                                            </template>

                                            <template #item.observations="scope">
                                                <div class="datatable-designation-text">
                                                    {{ scope.item.observations }}
                                                </div>
                                            </template>

                                            <template #[`item.actions`]="scope">
                                                <div v-if="userStore.hasPermissionTo('Request client details page changes')" class="d-flex justify-end align-center">
                                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" v-on="on" v-bind="attrs" style="cursor: pointer" @click="openAddressChangeDialog(scope.item)"> mdi-square-edit-outline </v-icon>
                                                        </template>
                                                        <span>{{ tb('Pedido de alteração') }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </div>
                                </div>

                                <!-- Dados Comerciais -->
                                <div class="client-tab" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('Dados Comerciais')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col cols="5">
                                            <div>
                                                <div class="title-text dark-blue-color">{{ tb('Dados Comerciais') }}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="7" style="right: 0px">
                                            <div v-if="userStore.hasPermissionTo('Access branch details 360 button')" class="d-flex justify-end">
                                                <v-btn text outlined class="myprovet-btn-cancel text-none px-8 ml-4 mr-2" :href="link360" target="_blank"><img class="rotate-360-svg" src="/storage/assets/rotate-360.svg" />&nbsp;{{ $t('branchDetails.platform360') }}</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <div class="px-3">
                                        <v-row class="my-0">
                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Tipo de cliente')" :value="getBranchType"></v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Condição de cliente')" :value="getBranchCondition"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row class="my-0">
                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Contacto do delegado(a)')" :value="getSellerPhoneNumber"></v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Nome do delegado(a)')" :value="getSellerDisplayName"></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="userStore.hasPermissionTo('Request client details page changes')" class="my-0">
                                            <v-col cols="3">
                                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-bind="attrs" v-on="on" style="width: fit-content">
                                                            <v-switch readonly class="mt-0" :label="tb('Aceito pendentes')" @click="isEditAcceptPendingDialogOpen = true" :input-value="getAcceptPendingProducts"></v-switch>
                                                        </div>
                                                    </template>

                                                    <span v-html="tHtml(pending_explanation_message)"></span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>

                                <!-- Dados Financeiros -->
                                <div class="client-tab" ref="detailsTab" v-if="selectedTabIndex === getSelectedTabIndex('Dados Financeiros')">
                                    <v-row class="d-flex align-center justify-space-between pb-2">
                                        <v-col cols="5">
                                            <div>
                                                <div class="title-text dark-blue-color">{{ tb('Dados Financeiros') }}</div>
                                            </div>
                                        </v-col>
                                        <v-col cols="7" style="right: 0px">
                                            <div v-if="userStore.hasPermissionTo('Access branch details 360 button')">
                                                <v-btn text outlined class="myprovet-btn-cancel text-none px-8 mr-2" :href="link360" target="_blank"><img class="rotate-360-svg" src="/storage/assets/rotate-360.svg" />&nbsp;{{ $t('branchDetails.platform360') }}</v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <div class="px-3">
                                        <v-row class="my-0">
                                            <v-col cols="3">
                                                <v-text-field readonly :label="tb('Condição de Pagamento')" :value="getPaymentCondition"></v-text-field>
                                            </v-col>

                                            <!-- <v-col cols="3">
                                                <v-text-field readonly :label="tb('Desconto Habitual (%)')" :value="getUsualDiscount"></v-text-field>
                                            </v-col> -->
                                        </v-row>
                                    </div>
                                </div>
                            </v-row>
                        </template>
                    </app-card>
                </div>
            </v-col>
        </v-row>

        <edit-accept-pending-products-dialog :value="isEditAcceptPendingDialogOpen" :accepts-pending-products="getAcceptPendingProducts" @on-success="isEditAcceptPendingDialogOpen = false" @on-cancel="isEditAcceptPendingDialogOpen = false"></edit-accept-pending-products-dialog>

        <branch-address-edit-dialog
            @on-cancel="isBranchAddressEditDialogOpen = false"
            v-if="isBranchAddressEditDialogOpen"
            :value="isBranchAddressEditDialogOpen"
            :originalAddress="selectedAddress"
            :branchId="getBranchId"
            @on-success="isBranchAddressEditDialogOpen = false"
        ></branch-address-edit-dialog>

        <app-dialog :value="isConfirmChangesDialogOpen" @input="isConfirmChangesDialogOpen = $event" :title="tb('Atenção!')" width="35vw">
            <template v-slot:content>
                <p class="dark-blue-color pt-4" style="font-size: 16px">{{ tb('Tem a certeza que deseja submeter o pedido de alteração dos dados fiscais?') }}</p>
            </template>

            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isConfirmChangesDialogOpen = false">{{ tb('Cancelar') }}</v-btn>
                <v-btn text class="myprovet-btn-ok px-8" @click="submitGeneralDataChanges">{{ tb('Confirmar') }}</v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { useAppStore } from '@/Stores/app';
import MainLayout from './../../Layouts/MainLayout';
import { axios } from '@/Services/Backend';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    props: {
        branch_addresses_headers: [Object, Array],
        link360: String,
        pending_explanation_message: String,
    },

    data: () => ({
        isLoading: false,
        datatableSize: 200,
        resizeObserver: null,
        generalDataSize: 200,
        selectedTabIndex: 0,
        unknownValue: ' ', // Keeps the field name above the field while viewing the data
        editingGeneralData: false,
        editedGeneralData: {},
        isBranchAddressEditDialogOpen: false,
        isEditAcceptPendingDialogOpen: false,
        selectedAddress: null,
        isConfirmChangesDialogOpen: false,
        tabItems: [],
    }),

    computed: {
        ...mapStores(useBranchStore, useUserStore,useAppStore),

        // Branch
        getBranchId() {
            return this.branchStore.branch?.id ?? this.unknownValue;
        },

        getBranchClientNumber() {
            return this.branchStore.branch?.client_number ?? this.unknownValue;
        },

        getBranchCompanyBranch() {
            return this.branchStore.branch?.company_branch ?? this.unknownValue;
        },

        getBranchName() {
            return this.branchStore.branch?.name || this.unknownValue;
        },

        getBranchEmail() {
            return this.branchStore.branch?.emails || this.unknownValue;
        },

        getBranchPhoneNumber() {
            return this.branchStore.branch?.phone_number || this.unknownValue;
        },

        getBranchTelephoneNumber() {
            return this.branchStore.branch?.telephone_number || this.unknownValue;
        },

        getBranchAddress() {
            return this.branchStore.branch?.address || this.unknownValue;
        },

        getPostalCode() {
            return this.branchStore.branch?.postal_code;
        },

        getLocation() {
            return this.branchStore.branch?.location;
        },

        getBranchNIF() {
            return this.branchStore.branch?.taxpayer_number ?? this.unknownValue;
        },

        getBranchCondition() {
            return this.branchStore.branch?.condition;
        },

        getSellerPhoneNumber() {
            return this.branchStore.branch?.seller?.phone_number || this.unknownValue;
        },

        getSellerDisplayName() {
            return this.branchStore.branch?.seller?.display_name || this.unknownValue;
        },

        getAcceptPendingProducts() {
            return this.branchStore.branch?.accept_pending;
        },

        getBranchType() {
            return this.branchStore.branch?.type?.type;
        },

        getPaymentCondition() {
            return this.branchStore.branch?.payment_condition?.description;
        },

        getUsualDiscount() {
            return this.branchStore.branch?.usual_discount ? parseFloat(this.branchStore.branch?.usual_discount) : this.unknownValue;
        },

        getBranchDeliveryAddresses() {
            return this.branchStore.getDeliveryAddresses;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    watch: {
        'userStore.user': {
            handler: function (user) {
                if (!user) return;
                this.setTabItems();
            },
            immediate: true,
        },
    },

    mounted() {
        this.prepareResponsiveBehaviour();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.detailsTab);
    },

    methods: {
        openAddressChangeDialog(address) {
            this.selectedAddress = address;
            this.isBranchAddressEditDialogOpen = true;
        },

        startGeneralDataChanges() {
            this.copyOriginalData();
            this.editingGeneralData = true;
        },

        copyOriginalData() {
            this.editedGeneralData.name = this.getBranchName === ' ' ? '' : this.getBranchName;
            this.editedGeneralData.emails = this.getBranchEmail === ' ' ? '' : this.getBranchEmail;
            this.editedGeneralData.phone_number = this.getBranchPhoneNumber === ' ' ? '' : this.getBranchPhoneNumber;
            this.editedGeneralData.telephone_number = this.getBranchTelephoneNumber === ' ' ? '' : this.getBranchTelephoneNumber;
            this.editedGeneralData.address = this.getBranchAddress === ' ' ? '' : this.getBranchAddress;
            this.editedGeneralData.taxpayer_number = this.getBranchNIF === ' ' ? '' : this.getBranchNIF;
            this.editedGeneralData.postal_code = this.getPostalCode === ' ' ? '' : this.getPostalCode;
            this.editedGeneralData.location = this.getLocation === ' ' ? '' : this.getLocation;
        },

        cancelGeneralDataChanges() {
            this.editingGeneralData = false;
        },

        submitGeneralDataChanges() {
            axios
                .post(`/api/branches/${this.branchStore.branch.id}/request-update`, this.editedGeneralData)
                .then(() => {
                    this.showSuccess(this.tb('O seu pedido de alterações foi enviado com sucesso!'));
                    this.editingGeneralData = false;
                    this.isConfirmChangesDialogOpen = false;
                })
                .catch(() => {
                    this.showError(this.tb('O envio do seu pedido de alterações falhou. Tente novamente mais tarde ou contacte diretamente a Propec.'));
                    this.loading = false;
                });
        },

        prepareResponsiveBehaviour() {
            // Table and General Data responsivity
            const makeResponsive = () => {
                this.$nextTick(() => {
                    this.computeDatatableSize();
                });
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);

            window.addEventListener('resize', makeResponsive);

            // Scroll arrow
            this.$nextTick(() => {
                this.resizeObserver.observe(this.$refs.detailsTab);
            });
        },

        computeDatatableSize() {
            this.datatableSize = window.innerHeight - 342;
            this.generalDataSize = this.editingGeneralData ? window.innerHeight - 348 : window.innerHeight - 340;
        },

        setTabItems() {
            let tabs = [];

            if (this.userStore.hasPermissionTo('View tax data')) tabs.push({ tab: 'Dados Fiscais' });
            if (this.userStore.hasPermissionTo('View shipping data')) tabs.push({ tab: 'Dados Expedição' });
            if (this.userStore.hasPermissionTo('View business data')) tabs.push({ tab: 'Dados Comerciais' });
            if (this.userStore.hasPermissionTo('View financial data')) tabs.push({ tab: 'Dados Financeiros' });

            this.tabItems = tabs;
        },

        getSelectedTabIndex(tab) {
            if (this.tabItems.length === 0) return 0;

            return this.tabItems.findIndex((obj) => {
                return obj.tab === tab;
            });
        },
    },
};
</script>

<style></style>

<style scoped>
.client-tab {
    padding-top: 12px;
}

.rotate-360-svg {
    margin-top: -4px;
    filter: invert(22%) sepia(20%) saturate(4200%) hue-rotate(187deg) brightness(89%) contrast(92%);
}
</style>
